import { Component, OnDestroy, OnInit, effect, input, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

import { Room } from '@era/locations-sdk';
import { Subscription } from 'rxjs';

@Component({
  selector: 'era-room-select-ui',
  templateUrl: './room-select.component.html',
  imports: [ReactiveFormsModule],
})
export class RoomSelectComponent implements OnInit, OnDestroy {
  readonly selectRoom = new UntypedFormControl('');

  readonly rooms = input.required<Room[]>();
  room: Room;

  readonly roomChange = output<Room>();

  private readonly subscriptions: Subscription[] = [];

  constructor() {
    effect(() => {
      const rooms = this.rooms();
      // when rooms is set, then set the depicted default (rooms[0]) as the default room
      if (rooms !== null && rooms.length > 0) {
        this.selectRoom.setValue(rooms[0]);
      }
    });
  }

  ngOnInit() {
    this.subscriptions.push(
      this.selectRoom.valueChanges.subscribe((room) => {
        this.roomChange.emit(room);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }
}
